import { debounce as _debounce, uniq as _uniq, uniq, filter } from "lodash";

const PlpFilters = el => {
  const checkboxes = [
    ...el.querySelectorAll("._js__plp-filters__option-checkbox"),
  ];
  const filterToggles = [
    ...el.querySelectorAll('._js__plp-filters__toggle'),
  ];
  const clearButtons = [
    ...document.querySelectorAll('._js__plp-clear-filters'),
  ];
  const filterBubbleLabels = [
    ...document.querySelectorAll("._js__filter_bubble_label")
  ];
  let selectedCheckboxIds = _uniq([
    ...el.querySelectorAll("._js__plp-filters__option-checkbox[checked]"),
  ].map(el => el.value.split("_")[1]));
  let filterGroupEls = [...document.querySelectorAll('._js__plp-filters__group')];
  if (selectedCheckboxIds.length > 0) clearButtons.forEach(el => el.disabled = false);
  
  const sortSelect = [...el.querySelectorAll("._js__plp-filters__sort-order")];

  let selectedSortValue = el.querySelector("._js__plp-filters__sort-order[checked]").value;
  let selectedSortKey = selectedSortValue.split('-')[0];
  let selectedSortOrder = selectedSortValue.split('-')[1];
  
  const resultsEl = document.querySelector("._js__plp-results");
  
  const addComponentsEvent = new Event("addcomponents");
  const loadStartEvent = new Event("loadstart");
  const loadEndEvent = new Event("loadend");
  const showHeaderEvent = new Event("showheader");
  
  let latestFetchTimestamp = null;

  const swapResults = (text, queryString, timestamp) => {
    if (timestamp !== latestFetchTimestamp) return;

    const doc = new DOMParser().parseFromString(text, "text/html");
    const newResultsEl = doc.querySelector("._js__plp-results");

    const onTransitionEnd = () => {
      window.scrollTo(0, 0);
      resultsEl.innerHTML = newResultsEl.innerHTML;
      resultsEl.removeEventListener("transitionend", onTransitionEnd);
      resultsEl.removeEventListener("webkitTransitionEnd", onTransitionEnd);
      resultsEl.style.opacity = 1;

      if (history.replaceState) {
        const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${queryString}`;
        window.history.replaceState({ path: newurl }, "", newurl);
      }

      window.dispatchEvent(addComponentsEvent);
      window.dispatchEvent(showHeaderEvent);

      setTimeout(() => {
        resultsEl.style.willChange = null;
      }, 333);
    }

    resultsEl.addEventListener("transitionend", onTransitionEnd);
    resultsEl.addEventListener("webkitTransitionEnd", onTransitionEnd);

    resultsEl.style.willChange = 'opacity';
    resultsEl.style.opacity = 0;

    updateGroupCounts();
  };

  const buildQueryString = () => {
    let queryString = `?sort=${selectedSortKey}&order=${selectedSortOrder}`;

    if (selectedCheckboxIds.length) {
      console.log('enable clear buttons');
      clearButtons.forEach(el => el.disabled = false);
      queryString += `&categories=${selectedCheckboxIds.join(",")}`;
    } else {
      console.log('disable clear buttons');
      clearButtons.forEach(el => el.disabled = true);
    }
    return queryString;
  };

  const fetchPageContent = _debounce(
    async () => {
      window.dispatchEvent(loadStartEvent);
      const now = new Date().getTime();
      latestFetchTimestamp = now;

      const queryString = buildQueryString();
      const uri = `${document.location.pathname}${queryString}`;

      try {
        const result = await fetch(uri);
        const text = await result.text();
        swapResults(text, queryString, now);
        window.dispatchEvent(loadEndEvent);
      } catch (error) {
        console.error(error);
        window.dispatchEvent(loadEndEvent);
      }
    },
    333,
    { leading: true, trailing: true }
  );

  const updateGroupCounts = () => {
    const overallCountEl = document.querySelector('._js__overall_plp_filter_count');
    var overallCount = 0;
    
    for (var i = 0; i < filterBubbleLabels.length; i++) {
      filterBubbleLabels[i].style.display = "none";
    }
    filterGroupEls.forEach(groupEl => {
      const checkedBoxes = groupEl.querySelectorAll('._js__plp-filters__option-checkbox:checked');
      const countEl = groupEl.querySelector('._js__plp-filters__toggle-count');
      if (countEl) {
        if (checkedBoxes.length) {
          countEl.innerHTML = checkedBoxes.length;
        } else {
          countEl.innerHTML = '';
        }
      }

      for (var i = 0; i < checkedBoxes.length; i++) {
        var filerBubbleLabel = document.querySelector("._js__filter_bubble_label[for=" + checkedBoxes[i].id + "]");
        filerBubbleLabel.style.display = "inline-block";
      }
      overallCount += checkedBoxes.length;
    });

    if (overallCountEl) {
      overallCountEl.innerHTML = overallCount;
    }
    if (overallCount > 0) {
      document.querySelector("._js__bubble-container").style.display = "block";
    } else {
      document.querySelector("._js__bubble-container").style.display = "none";
    }
  }

  const onChangeCheckbox = ({ currentTarget }) => {
    const [group, value] = currentTarget.value.split("_");
    const similarCheckboxEls = [...document.querySelectorAll(`._js__plp-filters__option-checkbox[value="${currentTarget.value}"]`)];
    similarCheckboxEls.forEach(twin => {
      if (twin !== currentTarget) {
        twin.checked = currentTarget.checked;
      }
    });

    selectedCheckboxIds = uniq(selectedCheckboxIds);
    const index = selectedCheckboxIds.indexOf(value);
    if (index > -1) {
      selectedCheckboxIds.splice(index, 1);
    } else {
      selectedCheckboxIds.push(value);
    }


    fetchPageContent();
  };

  const onChangeSortSelect = ({ currentTarget }) => {
    selectedSortKey = currentTarget.value.split('-')[0];
    selectedSortOrder = currentTarget.value.split('-')[1];

    fetchPageContent();
  };

  const onChangeToggle = ({ currentTarget }) => {
    // Close other toggles when one opens
    filterToggles.forEach(el => {
      if (el !== currentTarget) {
        el.checked = false;
      }
    });
  };

  const closeAllFilters = () => {
    filterToggles.forEach(el => el.checked = false);
    const focusedEls = [...el.querySelectorAll(':focus')];
    focusedEls.forEach(el => el.blur());
  }

  const onClickClear = e => {
    console.log('click clear');
    checkboxes.forEach(el => {
      if (!el.classList.contains("_js_default-category")) {
        el.checked = false
      }
    });
    selectedCheckboxIds = [];
    e.preventDefault();
    fetchPageContent();
  };

  const onKeyDown = e => {
    if (e.key.toLowerCase() === 'escape') {
      closeAllFilters();
    }
  }

  checkboxes.forEach(el => el.addEventListener("change", onChangeCheckbox));
  filterToggles.forEach(el => el.addEventListener("change", onChangeToggle));
  sortSelect.forEach(el => el.addEventListener("change", onChangeSortSelect));
  clearButtons.forEach(el => el.addEventListener("click", onClickClear));
  window.addEventListener('keydown', onKeyDown);
  updateGroupCounts();
};

export default PlpFilters;
